<template>

    <div id="vue_place_order">
    <header class="main_menu">
        <div class="container">
            
            <div class="row align-items-center">
                <div class="col-lg-12">
                <nav class="navbar navbar-expand-lg navbar-light">
                        <a class="navbar-brand" :href="'#/menu/'+restaurant_id+'/'+table_id"> <i style="background: #f7f7f7; padding: 4px 5px; border-radius: 5px; box-shadow: 2px 2px #d1cfcf; font-size: 12px;" class="fas fa-chevron-left"></i> </a>
						<a class="navbar-brand mr-auto" :href="'#/menu/'+restaurant_id+'/'+table_id"> <img :src="this.logo" style="object-fit: contain; max-height: 42px; border-radius: 33%;" @error="ResimageLoadError" alt="logo"> </a>
                        
						<ul style="margin-bottom: 0;padding-left:0;">
                        <li>
                        <i class="fas fa-globe  dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="font-size: 16px;
    margin-right: 10px;  padding-top: 5px;"></i>
                            <div class="dropdown-menu bgs" style="box-shadow: 2px 2px 7px #a7a7a7; left:auto; right:0;">
                            <a @click="handleChange('en-us')" :style="{color: eng_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="en"> <flag iso="us" /> English</a>
                            <!-- <a @click="handleChange('th')" :style="{color: thai_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="th"> <flag iso="th" /> ไทย </a>
                            <a @click="handleChange('ja')" :style="{color: jap_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="th"> <flag iso="jp" /> 日本 </a>
                            <a @click="handleChange('ko')" :style="{color: ko_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="th"> <flag iso="kp" /> 韓国語 </a>
                            <a @click="handleChange('it')" :style="{color: it_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="th"> <flag iso="it" /> italiano</a>
                            <a @click="handleChange('zh-hans')" :style="{color: ch_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="th"> <flag iso="cn" /> 简体中文</a> -->
                            <template v-for="lang in this.lang_list" :key="lang.id">
                                <a
                                @click="handleChange(lang.language)"
                                :style="{ color: lang_select == lang.language ? 'red' : '#000000' }"
                                class="dropdown-item"
                                data-value="th"
                            >
                            <template v-if="lang.language == 'uk'"> <flag iso="ua" /> {{lang.country}} </template> <template v-else> <flag :iso="lang.language" /> {{lang.country}} </template>
                            </a>
                            </template>
                            </div> 
                        </li>
                        </ul>
						<a style="margin-right: 1px;" class="navbar-brand" v-on:click="refreshpage()"><i class="fas fa-redo-alt" style="font-size: 16px;"></i></a>
						<ul style="margin-bottom: 0;padding-left:0;">
						<li>
							<!-- <i style="margin-left: 13px;" class="fas fa-ellipsis-v dropdown-toggle-split"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i> -->
                          <a :href="'#/order/history/'+session_id" class="dropdown-item" style="padding: 0.25rem 0rem 0.25rem 1rem;background-color: #fff;"><i class="fas fa-shopping-cart"></i></a>
							<!-- <div class="dropdown-menu bgs" style="box-shadow: 2px 2px 7px #a7a7a7; left:auto; right:0;">
								<a class="dropdown-item" v-on:click="addHelp();"> <i class="fas fa-concierge-bell"> {{ $t("message.help", {}, { locale: lang }) }} </i></a>
								<a :href="'#/restaurant/order/history/'+session_id" class="dropdown-item"><i class="fas fa-clipboard-list">  {{ $t("message.orderstatus", {}, { locale: lang }) }}</i></a>
							</div>	 -->
						</li>			
						</ul>       
                </nav>
                </div>
                
            </div>
        </div>
    </header>

    <div v-if="isLoading" style="text-align:center">
         <img src="" style="margin-top:120px;" @error="Loader" alt="logo">
    </div>

    <section class="exclusive_item_part blog_item_section" style="padding-top:0px;">
        <div class="container" v-show="isLoaded" @load="loaded">
			
            <div class="row">
                <div class="col">
                    <div id="m1">  
                        <p class="menu-title">{{ $t("message.orderdetails", {}, { locale: lang }) }}</p>
                    </div>
                </div>
            </div>
			<div class="row" v-for="(item, index) in items" :key="item.id" style="border-radius:11px;margin: 0;box-shadow: 0px 1px 2px 1px rgb(205 205 205);margin-bottom: 5px;padding: 10px 0;background-image: linear-gradient(to right, #ffffff , #ffffff);">
				<div class="col-7" >
					<p class="title" style="font-family: Okra,Helvetica,sans-serif !important; color:#555555; margin-bottom: 0px;">{{item.item_name}}</p>

                    <span style="font-size: 11px; color: #ff6426;" v-on:click="updateExtraItem(index);" v-show="item.session_extra_item_list.length >0">{{ $t("message.customize", {}, { locale: lang }) }} <i class="fas fa-chevron-down"></i><br/></span>
                    <span v-for="extra_item in item.session_extra_item" :key="extra_item.id" class="item_ls" style="color: #939393;
    font-size: 12px;">{{extra_item.extra_item}} {{currency}}{{extra_item.price}} </span>
					<span class="include">{{currency}} {{parseFloat(item.item_price).toFixed(2) }}</span>	
				</div>
				<div class="col-5 text-center">
					<div>
						<p class="price"><i class="fas"></i><span class="inner_price" style="font-size:16px; font-family:Okra,Helvetica,sans-serif !important;">{{currency}} {{parseFloat(item.item_total_price).toFixed(2) }}</span></p>
					</div>
					<div class="number btn" style="padding: 0px; top:0px;">
						<span class="minus fas fa-minus" style="padding-left: 7px;font-size:12px" v-on:click="manageItem(item.item.id,0,$event,index);"></span>
						<input style="padding-left: 0px; font-weight: 900;" class="inputt" type="button" :value="item.item_count"/>
						<span class="plus fas fa-plus" style="padding-right: 7px;font-size:12px" v-on:click="manageItem(item.item.id,1,$event,index);"></span>
					</div>
				</div>
                <hr/>
                
			</div>  
			
			
			<!-- <div class="row">
				<div class="col-12 text-center">
					<p class="title" style="margin-bottom: 0px; font-family:Okra,Helvetica,sans-serif !important;">  {{ $t("message.totalamount", {}, { locale: lang }) }}: {{currency}}{{parseFloat(total_cart_amount).toFixed(2) }}</p>
				</div>
			</div>
            <hr/> -->
            <div class="row">
                <div class="col-md-12 mb-3 mt-2">
                    <textarea class="form-control" maxlength="40" rows="2" id="user_instruction" :placeholder="$t('message.addinstruction' , {}, { locale: lang })"></textarea>
                </div>    
            </div> 
                        
            <!-- <div class="col-md-12 text-center">
				<a  class="genric-btn primary circle" style="font-size:15px; box-shadow: 2px 2px 7px #a7a7a7;" v-on:click="placeOrderCheck();"> {{ $t("message.placeorder", {}, { locale: lang }) }}</a>
			</div> -->
			<br/>
        </div>
    </section>
    <section style="visibility:hidden;">
        <div style="padding:30px 0 !important;"><p>&nbsp;</p></div>
    </section>
<section class="bottom-cart">
        <div class="container" v-show="isLoaded" @load="loaded">
            <div class="row">
			<div class="col-6">
                <span style="font-size:12px; color:f3f3f3;">{{cart_item}} {{ $t("message.totalamount", {}, { locale: lang }) }}</span>
				<p class="price" style="margin-bottom: 0px;"><i aria-hidden="true"></i> {{currency}} {{parseFloat(total_cart_amount).toFixed(2) }}</p>
                </div>
			<div class="col-6" style="z-index: 9999;"> 			
				<button id="place_ord" type="button" class="plsord btn btn-danger btn-block mt-1" v-on:click="placeOrderCheck($event);" :disabled=false>{{ $t("message.placeorder", {}, { locale: lang }) }}</button>
			</div>
			</div>
            
		</div>	
    </section>
<div class="modal fade" id="UserDetailModal" tabindex="-1" role="dialog" aria-labelledby="UserDetailModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog animate-bottom" role="document" style="margin: 0px; width: 100%;max-width: none;">
    <div class="modal-content">
      <div class="modal-body" style="background: #f1f1f1;">
		<div class="row">
			<div class="col-12" style="">
                <button type="button" data-dismiss="modal" aria-label="Close" class="close"><span aria-hidden="true">×</span></button>
				<!-- <span style="color:#787878; font-size:12px;">kdnald</span> -->
				<p class="title" style="font-weight:500; font-size: 22px !important; text-align:center;">{{ $t("message.customer_details", {}, { locale: lang }) }}</p>
			</div>
		</div>	
		<hr>
		<div class="row" style="overflow-y: scroll;
    max-height:169px; margin-bottom: 37px;">
			
			<!-- <div class="col-12">	
				<p class="title mb-1" style="font-weight:500;">Add on's</p>
			</div> -->
            <div class="col-md-12">
                    <div class="regervation_part_iner">
                        <form>
                            <div class="form-row">
                                <div class="form-group col-md-12" v-show="this.personal_name">
                                    <input type="text" class="form-control" id="name" :placeholder="$t('message.enter_name' , {}, { locale: lang })" required>
                                </div>
                                <div class="form-group col-md-12" v-show="this.personal_email">
                                    <input type="email" class="form-control" id="email" :placeholder="$t('message.enter_email' , {}, { locale: lang })" required>
                                </div>
                               
                                <div class="form-group col-md-12" v-show="this.personal_phone_no">
                                    <input type="number" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              maxlength = "10" class="form-control" id="phone" :placeholder="$t('message.enter_phone' , {}, { locale: lang })" required>
                                </div>
                                
                            </div>
                        </form>
                    </div>
                </div>
		</div>
		<!-- <section class="bottom-cart"> -->
        <!-- <div class="container"> -->
            <div class="row" style="background: white;
                position: fixed;
                bottom: 0;
                width: 100%;
                z-index: 111;
                padding: 5px;">
				<div class="col-12">			
					<button id="place_or" type="button" @click="placeOrder($event);" class="plsord btn btn-danger btn-block mt-1" :disabled=false>{{ $t("message.submit", {}, { locale: lang }) }}</button>
				</div>
			</div>
		<!-- </div>	 -->
    <!-- </section> -->
		
	</div>
    </div>
  </div>
</div>

<div class="modal fade" id="extraItemUpdateModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog animate-bottom" role="document" style="margin: 0px; width: 100%;max-width: none;">
    <div class="modal-content">
      <div class="modal-body" style="background: #f1f1f1;">
		<div class="row">
			<div class="col-12" style="">
                <button type="button" data-dismiss="modal" aria-label="Close" class="close"><span aria-hidden="true">×</span></button>
				<span style="color:#787878; font-size:12px;">{{this.extra_item_name}}</span>
				<p class="title" style="font-weight:500; font-size: 22px !important;">{{ $t("message.customise_test", {}, { locale: lang }) }}</p>
			</div>
		</div>	
		<hr>
		<div class="row" style="overflow-y: scroll;
    max-height:169px; margin-bottom: 37px;">
			
			<div class="col-12">	
				<p class="title mb-1" style="font-weight:500;">{{ $t("message.add_ons", {}, { locale: lang }) }}</p>
			</div>
			<div class="col-12 mb-1" v-for="(ex_item) in extra_items" :key="ex_item.id">	
				<div class="addon">
				<p style="margin-right:50px; line-height:1.2; margin-bottom: 0px; font-size: 22px;">
				{{ ex_item.extra_item }}
				</p>
				<p style="position:absolute;top:10px;right:20px; font-family:Okra,Helvetica,sans-serif !important;">
				<!-- <i class="fas fa-rupee-sign" style="color: #4d4d4e; font-size: 12px;"></i>{{ ex_item.price }} <input style="height: 14px !important; margin-bottom: 6px;" @change="checkAddon($event, ex_item.id, index)" type="checkbox" > -->
                {{this.currency}} {{parseFloat(ex_item.price).toFixed(2) }} <input :value="ex_item.id" style="height: 14px !important; margin-bottom: 2px;" :checked="isInGrupMenu(ex_item.id)"  @change="checkAddon($event,ex_item.price, ex_item.id, index)" type="checkbox" >
				</p>
				</div>
			</div>
		</div>
		<!-- <section class="bottom-cart"> -->
        <!-- <div class="container"> -->
            <div class="row" style="background: white;
                position: fixed;
                bottom: 0;
                width: 100%;
                z-index: 111;
                padding: 5px;">
				<div class="col-5">
                   
                <p class="price" style="font-family:Okra,Helvetica,sans-serif !important;">{{this.currency}} {{parseFloat(this.extra_item_price).toFixed(2) }}</p>
                </div>
				<div class="col-7">			
					<button type="button" @click="ItemWithExtra(this.extra_item_id)" class="btn btn-danger btn-block mt-1">{{ $t("message.update_item", {}, { locale: lang }) }}</button>
				</div>
			</div>
		<!-- </div>	 -->
    <!-- </section> -->
		
	</div>
    </div>
  </div>
</div>

</div>
</template>

<script>
import "@meforma/vue-toaster";
export default {
    name: "OrderDetail",
    data: function(){
        return {
        total_cart_price:0,
        items:[],
        session_id:null,
        restaurant_id:null,
        table_id:null,
        currency:null,
        logo:null,
        table_menu:null,
        lang: "",
        eng_lang: false,
        thai_lang: false,
        jap_lang: false,
        ko_lang: false,
        it_lang: false,
        ch_lang: false,
        ru_lang: false,
        uk_lang: false,
        isLoaded: false,
        isLoading: false,
        personal_name: '',
        personal_email: '',
        personal_phone_no: '',
        extra_items: [],
        extra_item_name: '',
        extra_item_price: '',
        checkedProducts: [],
        extra_item_id: '',
        session_extra_item: [],
        session_item_id: [],
        new_session_id_list: [],
        old_session_id_list: [],
        updated_session_id_list: [],
        sessionitem_tablesession: null,
        lang1: false,
        lang2: false,
        lang_select : '',
        lang_list: [],
        clicks: 0,
        result: [],
        }
    },
    methods: {
        
        loaded: function() {
        this.isLoaded = true;
        this.isLoading = false;
    },
    isInGrupMenu(id) {
        return this.new_session_id_list.some((item) => item.id === id);
    },
    closeModel: function(){
        location.reload();
      },
    ItemWithExtra: function(id){
            // alert(this.updated_session_id_list); 
              
            // alert(this.old_session_id_list);   
            // alert(this.session_id);     
            // alert(1); 
            // alert(this.lang);
            // alert(id)
            var data = {
                "order_json": {"session_uuid": this.session_id, "item_id": id, "manage_type": 2, "language_code":this.lang, "extra_item":this.updated_session_id_list, "old_extra_item":this.old_session_id_list}
            }
            var config = {
                method: 'post',
                    url: process.env.VUE_APP_BASE_URI+'/api/userapi/order/manage/details/add_on/',
                    data: data,
                    headers: {
                }
            };
            this.axios(config)
            .then(response => {
            if(response.status){
                this.jQuery("#extraItemUpdateModal").modal('hide');
                console.log("res data:", response.data);
                this.session_item_id = [];
                this.old_session_id_list = [];
                this.updated_session_id_list = [];
                this.items = response.data.data.sessionitem_tablesession;
                console.log("table menu:", this.items);
                this.total_cart_amount = response.data.data.total_item_price;
                this.cart_item = response.data.data.total_item_count;
            }
            });
            
        },
    checkAddon: function(event,price,id,index){
          if(event.target.checked){
              console.log(this.new_session_id_list);
              console.log(this.session_extra_item);
              
              this.extra_item_price = this.extra_item_price + price;
              this.updated_session_id_list.push(id);
              console.log(this.updated_session_id_list);
              console.log(this.old_session_id_list);
            //   alert(this.session_extra_item);
            //   alert(this.new_session_id_list);
          }
          else{
              this.extra_item_price = this.extra_item_price - price;
              let found = this.updated_session_id_list.indexOf(id)
              this.updated_session_id_list.splice(found, 1)
              console.log(this.updated_session_id_list);
              console.log(this.old_session_id_list);
          }
          console.log(event);
          console.log(index);
      },
    updateExtraItem: function(index){
                // alert("hi");
                this.extra_items = this.items[index].session_extra_item_list;
                var test = this.items[index].session_extra_item;
                this.session_extra_item = this.items[index].session_extra_item;
                for(var i=0; i< this.session_extra_item.length; i++){
                    this.old_session_id_list.push(this.session_extra_item[i].id)
                }
                for(var j=0; j< this.session_extra_item.length; j++){
                    this.updated_session_id_list.push(this.session_extra_item[j].id)
                }
                console.log(this.old_session_id_list);
                console.log(this.updated_session_id_list);
                this.new_session_id_list = test;
                // console.log(this.items);
                console.log("sesion:", this.session_extra_item);
                console.log("new:", this.new_session_id_list);
                this.extra_item_name = this.items[index].item_name;
                this.extra_item_price = this.items[index].item_total_price;
                this.extra_item_id = this.items[index].item.id;
                this.jQuery("#extraItemUpdateModal").modal('show');
    },
    Loader: function(event){
            event.target.src = require("@/assets/website/img/loading.gif");
        },
        manageItem: function(item_id,manage_type,event,index){
            // alert(manage_type);
            this.session_extra_item = this.items[index].session_extra_item;
            // alert(this.session_extra_item.length);
            for(var i=0;i<this.session_extra_item.length;i++){
                this.session_item_id.push(this.session_extra_item[i].id);
            }
            console.log("session_id", this.session_item_id);
            var data = {
                "order_json": {"session_uuid": this.session_id, "item_id": item_id, "manage_type":manage_type, "language_code":this.lang, "extra_item":this.session_item_id, "old_extra_item": []}
            }
            
            // console.log(price)
            var $ = this.jQuery;
            var $input = $(event.target.parentElement).find('input');
            var count = parseInt($input.val());
            if(count <= -1){
                return false
            }
            
            var config = {
                method: 'post',
                    url: process.env.VUE_APP_BASE_URI+'/api/userapi/order/manage/details/add_on/',
                    data: data,
                    headers: {
                }
            };
            this.axios(config)
            .then(response => {
            if(response.status){
                console.log("res data:", response.data);
                this.session_item_id = [];
                this.items = response.data.data.sessionitem_tablesession;
                this.sessionitem_tablesession = response.data.data.sessionitem_tablesession;
                console.log("table menu:", this.items);
                this.total_cart_amount = response.data.data.total_item_price;
                // this.cart_item = response.data.data.sessionitem_tablesession;
                console.log(this.items.length);
            }
            if (this.items.length <= 0){
                this.$router.push({ name: 'OrderEmpty' })
            }
            });
            
         },
         placeOrder: function(event){

            var name = this.jQuery("#name").val();
            var email = this.jQuery("#email").val();
            var phone = this.jQuery("#phone").val();
            if(this.personal_name && name == ''){
                // alert("Please enter name");
                this.$toast.error(this.$t("message.enter_name", {}, { locale: this.lang }),{
                    position:"bottom",
                    duration:3000
                    })
                // name = '';
                return false;
            }
            if(this.personal_email && email == ''){
                // alert("Please enter email");
                this.$toast.error(this.$t("message.enter_email", {}, { locale: this.lang }),{
                    position:"bottom",
                    duration:3000
                    })
                // email = '';
                return false;
            }
            if(this.personal_phone_no && phone == ''){
                // alert("Please enter phone");
                this.$toast.error(this.$t("message.enter_phone", {}, { locale: this.lang }),{
                    position:"bottom",
                    duration:3000
                    })
                // phone = '';
                return false;
            }
        
            if(email){
                var res = email.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g);
                if(res == null){
                    this.$toast.error(this.$t("message.entervalidemail", {}, { locale: this.lang }),{
                        position:"bottom",
                        duration:3000
                        })
                    // phone = '';
                    return false;
                }
            }
            var config = {
                method: 'get',
                    url: process.env.VUE_APP_BASE_URI+'/api/userapi/order/details/add_on/'+this.session_id+'/'+this.lang,
                    headers: {
                }
            };
            this.axios(config)
            .then(response => {
            if(response.status){
 
        
                if (this.cart_item <= 0){
                this.$router.push({ name: 'OrderEmpty' });
                this.$toast.error(this.$t("message.place_order", {}, { locale: this.lang }),{
                    position:"bottom",
                    duration:3000
                    })
                }
                else{

                
                this.sessionitem_tablesession = this.items;
                if(this.lodash.isEqual(JSON.stringify(this.items), JSON.stringify(this.sessionitem_tablesession))){
                    if(this.clicks === 1) {
                        
                        var self = this
                        self.result.push(event.type);
                        self.clicks = 0
                    console.log("item comp:", this.items);
                    console.log("sess comp:", this.sessionitem_tablesession);
                        var  instruction = this.jQuery('#user_instruction').val();
                        
                        var ranges = [
                                        '\ud83c[\udf00-\udfff]', // U+1F300 to U+1F3FF
                                        '\ud83d[\udc00-\ude4f]', // U+1F400 to U+1F64F
                                        '\ud83d[\ude80-\udeff]'  // U+1F680 to U+1F6FF
                                        ];
                        var instruction_without_emoji = instruction.replace(new RegExp(ranges.join('|'), 'g'), '');
                        localStorage.setItem("instruction",instruction_without_emoji);
                        localStorage.setItem("name",name);
                        localStorage.setItem("email",email);
                        localStorage.setItem("phone",phone);
                        localStorage.removeItem("tip_amount");
                        localStorage.removeItem("tip");
                        var data = new this.formdata();
                        data.append('session_uuid',this.session_id);
                        data.append('language_code',this.lang);
                        data.append('instruction',localStorage.getItem('instruction'));
                        data.append('name', name);
                        data.append('email', email);
                        data.append('phone_number', phone);
                        // alert("hi");
                        this.jQuery("#place_or").prop("disabled", true);
                        var config = {
                        method: 'post',
                        url: process.env.VUE_APP_BASE_URI+'/api/userapi/order/place/',
                        headers: {
                        },
                        data:data,
                        }
                    this.axios(config)
                    .then(response => {
                    if(response.status){
            
                        // this.data = response.data.data;
                        // console.log("placed data:",this.data);
                        this.jQuery("#place_or").prop("disabled", false);
                        localStorage.setItem("personal_detail", "true");
                        this.jQuery('#UserDetailModal').modal('hide');
                        this.$router.push(
                            {   name:"OrderSuccess",
                                params: { data: response.data.data.total_price,
                                          data1: JSON.stringify(response.data.data) }
                            });
                        // this.items = response.data.data.recent_ordered_item;
                        // this.total_price = response.data.data.total_price
                        // localStorage.removeItem('instruction');
                    }
                    });   
                    
                    }
                    else{
                        this.clicks = 0;
                    }
                    
                }else{
                    console.log("else:", this.items);
                    console.log("else", this.sessionitem_tablesession);
    
                    
                    this.$toast.error(this.$t("message.revieworder", {}, { locale: this.lang }),{
                    position:"bottom",
                    duration:3000
                    })
                    this.items = this.sessionitem_tablesession;
                    this.total_cart_amount = response.data.data.total_item_price;
                    
                }
                }
                
            }
            });
            
            
         },
         placeOrderCheck: function(event){
             
             this.clicks++ ;
             if(!navigator.onLine){
                 this.$toast.error(this.$t("message.no_internet", {}, { locale: this.lang }),{
            position:"bottom",
            duration:2000
            })
             }
             else{
            var config = {
            method: 'get',
                url: process.env.VUE_APP_BASE_URI+'/api/check/personal/permission/'+this.restaurant_id+'/',
                headers: {
                }
            };
            this.axios(config)
            .then(response => {
            if(response.status){
                // console.log(response.data.data.permission_list[0]);
                this.personal_name = response.data.data.permission_list[0]['personal_name'];
                this.personal_email = response.data.data.permission_list[0]['personal_email'];
                this.personal_phone_no = response.data.data.permission_list[0]['personal_phone_no'];
                var personal_detail = localStorage.getItem('personal_detail');
                this.personal_detail = personal_detail;
                if(this.personal_name && !this.personal_detail  || this.personal_email && !this.personal_detail || this.personal_phone_no && !this.personal_detail){
                this.jQuery('#UserDetailModal').modal('show');
                }
                else{
        //             var config3 = {
        // method: 'get',
        //     url: process.env.VUE_APP_BASE_URI+'/api/user/payment/status/'+this.session_id+'/',
        //     headers: {
        //     }
        // };
        // this.axios(config3)
        // .then(response => {
            
        // if(response.data.data.payment_status){
       
        //     this.$toast.error(response.data.message,{
        //             position:"bottom",
        //             duration:3000
        //             })
        //     return false;
        // }
        
        //      else{
            var config = {
                method: 'get',
                    url: process.env.VUE_APP_BASE_URI+'/api/userapi/order/details/add_on/'+this.session_id+'/'+this.lang,
                    headers: {
                }
            };
            this.axios(config)
            .then(response => {
            if(response.status){
 
        
                if (this.cart_item <= 0){
                this.$router.push({ name: 'OrderEmpty' });
                this.$toast.error(this.$t("message.place_order", {}, { locale: this.lang }),{
                    position:"bottom",
                    duration:3000
                    })
                }
                else{
                if(this.lodash.isEqual(JSON.stringify(this.items), JSON.stringify(this.sessionitem_tablesession))){
                    if(this.clicks === 1) {
                        var self = this;
                        self.result.push(event.type);
                        self.clicks = 0
                        var  instruction = this.jQuery('#user_instruction').val();
                        if(!localStorage.getItem('email')){
                            var e_address = '';
                        }
                        else{
                            e_address = localStorage.getItem('email');
                        }
                        this.jQuery("#place_ord").prop("disabled", true);
                        this.isLoaded =  false;
                        this.isLoading = true;
                        var ranges = [
                                        '\ud83c[\udf00-\udfff]', // U+1F300 to U+1F3FF
                                        '\ud83d[\udc00-\ude4f]', // U+1F400 to U+1F64F
                                        '\ud83d[\ude80-\udeff]'  // U+1F680 to U+1F6FF
                                        ];
                        var instruction_without_emoji = instruction.replace(new RegExp(ranges.join('|'), 'g'), '');
                        localStorage.setItem("instruction",instruction_without_emoji);
                        var data = new this.formdata();
                        data.append('session_uuid',this.session_id);
                        data.append('language_code',this.lang);
                        data.append('instruction',localStorage.getItem('instruction'));
                        data.append('name', localStorage.getItem('name'));
                        data.append('email', e_address);
                        data.append('phone_number', localStorage.getItem('phone'));
                        localStorage.removeItem("tip_amount");
                        localStorage.removeItem("tip");
                        
                        var config = {
                        method: 'post',
                        url: process.env.VUE_APP_BASE_URI+'/api/userapi/order/place/',
                        headers: {
                        },
                        data:data,
                        }
                    this.axios(config)
                    .then(response => {
                    if(response.status){
                        
                        this.jQuery("#place_ord").prop("disabled", false);
                        this.isLoaded =  true;
                        this.isLoading = false;
                        // this.data = response.data.data;
                        console.log("placed data:",this.data);
                        this.$router.push(
                            {   name:"OrderSuccess",
                                params: { data: response.data.data.total_price,
                                          data1: JSON.stringify(response.data.data) }
                            });
                        // this.items = response.data.data.recent_ordered_item;
                        // this.total_price = response.data.data.total_price
                        // localStorage.removeItem('instruction');
                    }
                    });
                    }
                    else{
                        this.clicks = 0;
                    }      
                    
                }
                else{
    
                    
                    this.$toast.error(this.$t("message.revieworder", {}, { locale: this.lang }),{
                    position:"bottom",
                    duration:3000
                    })
                    this.items = this.sessionitem_tablesession;
                    this.total_cart_amount = response.data.data.total_item_price;
                    
                }
                }
                
            }
            });
            
            // }
            // });
                }
            }
            });
             
            }
        },
         addHelp: function(event){
            this.$toast.error(this.$t("message.helpwaiter", {}, { locale: this.lang }),{
            position:"bottom",
            duration:2000
            })
            var config = {
            method: 'get',
                url: process.env.VUE_APP_BASE_URI+'/api/userapi/waiter/help/'+this.session_id+'/'+this.lang,
                headers: {
                }
            };
            this.axios(config)
            .then(response => {
            if(response.status){
                console.log(response.status);
            }
            });
            event.preventDefault();
        },
        ResimageLoadError: function(event){
            event.target.src = require("@/assets/website/img/logo.png");
        },
        refreshpage: function(){
            if(navigator.onLine){
            window.location.reload();
            }
            else{
                this.$toast.error(this.$t("message.no_internet", {}, { locale: this.lang }),{
            position:"bottom",
            duration:2000
            })
            }
        },
        handleChange: function(a){
            localStorage.setItem('lang', a);
            this.lang = a;
            if (a === 'en-us') {
                this.eng_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = '';
            }
            else if (a === 'th'){
                // this.thai_lang = true;
                // this.eng_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'ko'){
                // this.ko_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.eng_lang = false;
                // this.it_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'ja'){
                // this.jap_lang = true;
                // this.thai_lang = false;
                // this.eng_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'it'){
                // this.it_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.eng_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'zh-hans'){
                // this.ch_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.eng_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'ro'){
                // this.ro_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.eng_lang = false;
                // this.ch_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'ru'){
                // this.ru_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.eng_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'uk'){
                // this.uk_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.eng_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            var config = {
            method: 'get',
            url: process.env.VUE_APP_BASE_URI+'/api/userapi/order/details/add_on/'+this.session_id+'/'+this.lang+'/',
            headers: {
            }
            };
            this.axios(config)
            .then(response => {
                 
            if(response.status){
                // var data = response.data.data;
                // console.log(data);
                this.items = response.data.data.sessionitem_tablesession;
                this.total_cart_amount = response.data.data.total_item_price;
                this.table_menu = response.data.data.table_menu;
        if (this.cart_item <= 0){
            this.$router.push({ name: 'OrderEmpty' });
        }
      }
    });
        }
    },
    mounted: function(){
    if(!localStorage.getItem('session_id')){
          this.$router.push('/pagenotfound/');
      }
    this.jQuery(window).scroll(function () {
    var window_top = this.jQuery(window).scrollTop() + 1;
    if (window_top > 10) {
      this.jQuery('.main_menu').addClass('menu_fixed animated');
    } else {
      this.jQuery('.main_menu').removeClass('menu_fixed animated');
    }
  });  
    var session_id = localStorage.getItem('session_id');
    var restaurant_id = localStorage.getItem('restaurant_id');
    var table_id = localStorage.getItem('table_id');
    var currency = localStorage.getItem('currency');
    var lang = localStorage.getItem('lang');
    this.logo = localStorage.getItem('logo');
    this.restaurant_id = restaurant_id;
    this.table_id = table_id;
    this.session_id = session_id;
    this.currency = currency;
    this.lang = lang;
    if (this.lang === 'en-us') {
        this.eng_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = '';
    }
    else if (this.lang  === 'th'){
        // this.thai_lang = true;
        // this.eng_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'th';
        this.eng_lang = false;
    }
    else if (this.lang  === 'ko'){
        // this.ko_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.eng_lang = false;
        // this.it_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'ko';
        this.eng_lang = false;
    }
    else if (this.lang  === 'ja'){
        // this.jap_lang = true;
        // this.thai_lang = false;
        // this.eng_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'ja';
        this.eng_lang = false;
    }
    else if (this.lang  === 'it'){
        // this.it_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.eng_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'it';
        this.eng_lang = false;
    }
    else if (this.lang  === 'zh-hans'){
        // this.ch_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.eng_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'zh-hans';
        this.eng_lang = false;
    }
    else if (this.lang === 'ro'){
        // this.ro_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.eng_lang = false;
        // this.ch_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'ro';
        this.eng_lang = false;
    }
    else if (this.lang === 'ru'){
        // this.ru_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.eng_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'ru';
        this.eng_lang = false;
    }
    else if (this.lang === 'uk'){
        // this.uk_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.eng_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        this.lang_select = 'uk';
        this.eng_lang = false;
    }
    this.isLoaded =  false;
    this.isLoading = true;
    
    if (this.cart_item <= 0){
        this.$router.push({ name: 'OrderEmpty' })
    }
    
    var config = {
      method: 'get',
      url: process.env.VUE_APP_BASE_URI+'/api/userapi/order/details/add_on/'+this.session_id+'/'+this.lang+'/',
      headers: {
      }
    };
    this.axios(config)
    .then(response => {
        
        if(response.data.code == 200){
            this.isLoaded =  true;
            this.isLoading = false;
        var data = response.data.data;
        console.log(data);
        this.items = response.data.data.sessionitem_tablesession;
        console.log("items:", this.items);
        // console.log("ex list:", this.items[4].session_extra_item);
        this.total_cart_amount = response.data.data.total_item_price;
        console.log("cart:", this.total_cart_amount);
        this.sessionitem_tablesession = response.data.data.sessionitem_tablesession;
        console.log("sess:",this.sessionitem_tablesession);
        
        if (response.data.data.sessionitem_tablesession.length <= 0){
            this.$router.push({ name: 'OrderEmpty' });
        }
      }
      else{
        var session_id = localStorage.removeItem('session_id');
        this.session_id = session_id;
        
        localStorage.removeItem('pin')
        localStorage.removeItem('order_id')
        this.$router.push('#/'+this.restaurant_id+'/'+this.table_id);
      }
    });
    var config5 = {
      method: "get",
      url:process.env.VUE_APP_BASE_URI +
        "/api/userapi/language/list/" +
        this.restaurant_id +
        "/",
      headers: {},
    };
    this.axios(config5).then((response) => {
      if (response.status) {

          this.lang_list = response.data.data;          
      }
    });
  }
    
}
</script>


<style scoped>
p{
    /* font-family: Okra,Helvetica,sans-serif !important; */
    font-family: Okra,Helvetica,sans-serif !important;
}
a:hover {
  text-decoration: none;
}
.hov{
    color: #000;
}
.hov:hover{
    color: #000 !important;
}
.tag{
height: max-content;
width: max-content;
background: #ff376e;
-webkit-box-align: center;
align-items: center;
-webkit-box-pack: center;
justify-content: center;
border-radius: 5px;
color: rgb(255, 255, 255);
font-size: 0.66rem;
border: none;
padding: 0.2rem 0.2rem;
letter-spacing: 1px;
}
.title{
    line-height: 1.2;
    /* font-weight:bold; */
    font-size:22px;
    color: #262626;
     margin-bottom: 0;
}
.addon{
    background:white; padding:8px 10px; border-radius:8px; border:1px solid #e7e7e7;
}
.menu_fixed { 
  position: fixed;
  z-index: 9999 !important;
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.05);
  top: 0;
}
.include{
    font-size: 14px;
    color: #7c7c7c;;
    display:block;
}
.item{
    border-radius: 5px;
}
.price{
font-weight: bold;
margin-bottom: 0px;
}
.pres{
    padding:0px !important;
}
.rrr{
    font-size: 18px;padding: 0px 5px 0px 5px;
}
.icount{
    padding-left: 0.2px; 
    font-weight: 900;
    line-height: 0.5px;
    appearance: none;
}
.rcount{
    padding-right: 0px;font-size:15px;padding-left: 3px;
}
.item_ls {
    display: block;
}
.lcount{
    padding-left: 0px; font-size:17px;padding-right: 8px;
}
span {cursor:pointer; }
    .number{
        background: #ffeef5 !important;
        text-align: center !important;
        border-radius: 5px !important;
        position: relative !important;
        /* bottom: 11px !important; */
        top: 14px;
        /* left: 18px; */
        border: 2px solid #ff5f8b !important;
    }
    /* input{
        height:20px !important;
        width:22px !important;
        text-align: center !important;
        font-size: 16px !important;
        background: #ffeef5 !important;
        border: 1px solid #ffeef5 !important;	
        display: inline-block !important;
        vertical-align: middle !important;
    } */
    hr {
      margin-top: 0.40rem;
      margin-bottom: 1rem;
      border: 0;
      border-top: 1px solid rgba(223 220 220 / 70);
    }
    .menu-title{
        font-size: 17px;
        line-height: 1;
        padding: 1rem 0px;
        color: #000;
        margin: 0px;
        margin-block-end: 0px;
        position: sticky;
        top: 106px;
        font-weight:bold;
        z-index: 1;
        display: flex;
    }
    .brad{
        border-radius:11px;
    }
    .bottom-cart{
        background: white;
        padding: 5px 0;
        position: fixed;
        bottom: 0;
        width: 100%;
        z-index: 111;
        box-shadow: rgb(125 125 125 / 45%) 0px 2px 8px;
        margin-top: 20px;
    }
    .adbtn{
        border-radius: 5px; background:#fff !important;
        color: #ff5f8b !important;
        font-size: 14px;font-weight: 600; border: 2px solid #ff5f8b !important;
        position: relative !important;
        /* bottom: 8px !important; */
        top: 14px;
        min-width: 83px !important;
        height: 32px !important;
    }
    .adbtnro{
        border-radius: 5px; background:#fff !important;
        color: #ff5f8b !important;
        font-size: 14px;font-weight: 600; border: 2px solid #ff5f8b !important;
        position: relative !important;
        /* bottom: 8px !important; */
        top: 14px;
        min-width: 91px !important;
        height: 32px !important;
    }
.scroll {
display: flex;
flex-wrap: nowrap;
overflow: auto;
-webkit-overflow-scrolling: touch;
-ms-overflow-style: -ms-autohiding-scrollbar; }
.flex {
display: flex;
flex-wrap: nowrap; }
.nav-item {
flex: 0 0 auto; }
.example-three{
display: block;
border: none; }
.example-three .nav-item {
color: #f6f7ee; }
.example-one-header,
.example-two-header {
border-radius: 3px; }
.example-three-header {
border-radius: 3px 3px 0 0; }
.example-three nav {
background: #727c87; 
border-radius: 0 0 3px 3px; 
}
.nav-item {
padding: 3px 7px;
background-color: rgb(255, 255, 255);
box-shadow: rgb(54 54 54 / 6%) 0px 1px 2px;
border-radius: 6px;
border: 1px solid #c0bfbf;
margin: 8px 8px 4px 0px;
display: flex;
-webkit-box-align: center;
align-items: center;
cursor: pointer;
color: #777777;
}
.titlee {
margin: 24px 0 6px;
font-size: 12px;
text-transform: uppercase;
letter-spacing: .2em;
color: #999; }
.st{
display: flex;
position: sticky;
background-color: rgb(255, 255, 255);
z-index: 2;
transition: top 0.5s ease-in-out 0s;
}
.scrolla{
border: 1px solid #dc3545;
color: #dc3545;}
.scrollb{
background: #ff376e;
color: #fff;
}
.scroll::-webkit-scrollbar {
display: none; }	
.iii {
-webkit-box-align: center;
align-items: center;
background: rgb(255, 255, 255);
height: 2.3rem;
position: sticky;
top: 34px;
z-index: 111;
margin-bottom: 13px;
}  
.prat{
    font-size:13px; font-weight:600; color:#1f1a18;
}
@media (min-width: 768px)
.example-one {
max-width: 740px !important;
} 
@keyframes example {
from {background-color: #007bff;}
to {background-color: #ff6325;}
}
.ribbon {
  position: absolute;
  right: 0px !important;
  top: -5px;
  z-index: 1;
  overflow: hidden;
  width: 75px; height: 75px;
  text-align: right;
}
.ribbon span {
  font-size: 9px;
  font-weight: bold;
  color: #FFF;
  text-transform: uppercase;
  text-align: center;
  line-height: 16px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  width: 104px;
  display: block;
  background: #ff376e;
  background: linear-gradient(#ff376e 0%, #dc3545 100%);
  box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
  position: absolute;
  top: 25px; 
  right: -20px;
}
.ribbon span::before {
  content: "";
  position: absolute; left: 0px; top: 100%;
  z-index: -1;
  border-left: 3px solid #dc3545;
  border-right: 3px solid transparent;
  border-bottom: 3px solid transparent;
  border-top: 3px solid #dc3545;
}
.ribbon span::after {
  content: "";
  position: absolute; right: 0px; top: 100%;
  z-index: -1;
  border-left: 3px solid transparent;
  border-right: 3px solid #dc3545;
  border-bottom: 3px solid transparent;
  border-top: 3px solid #dc3545;
}
.bmw{
    border-bottom: 1px dashed #efefef;
    border-radius: 10px; 
    margin-bottom: 16px;
}
.kia{
    border-radius: 4px;
    box-shadow: rgb(0 0 0 / 13%) 2px 2px 10px;
    margin: 0 -6px;
}
.kiap{
    padding: 11px;
}
.animate-bottom {
 position: fixed;
    animation: animatebottom 0.8s;
    bottom: 0;
}
.vcvc {
overflow-x: scroll;
}
.vcvc::-webkit-scrollbar {
 width: 2px;
 height: 1px;
 background-color: #fff;
 display:block;
}
.vcvc::-moz-scrollbar {
width: 2px;
 height: 1px;
 background-color: #fff;
 display:block;
}
.vcvc::-webkit-scrollbar-thumb {
 background: #000;
}
.vcvc::-moz-scrollbar-thumb {
 background: #000;
}
@keyframes animatebottom {
  from {
    bottom: -300px;
    opacity: 0;
  }
  to {
    bottom: 0;
    opacity: 1;
  }
}
</style>